const notifications = {
  // Page title
  title: 'الإشعارات',
  allNotifications: 'جميع الإشعارات',

  // Header
  header: {
    title: 'الإشعارات',
    markAllRead: 'تحديد الكل كمقروء',
    viewAll: 'عرض الكل',
    noNotifications: 'لا توجد إشعارات',
    noNotificationsDescription: 'ستظهر إشعاراتك هنا',
  },

  // Notification types
  types: {
    listing_view: 'مشاهدة إعلان',
    listing_contact: 'تواصل جديد',
    listing_save: 'حفظ إعلان',
    listing_expiry: 'انتهاء إعلان',
    subscription_renewal: 'تجديد الاشتراك',
    subscription_expiry: 'انتهاء الاشتراك',
    license_expiry: 'انتهاء الرخصة',
    new_review: 'تقييم جديد',
    lead_response: 'رد على طلب',
    system: 'إشعار النظام',
    promotion: 'عروض ترويجية',
  },

  // Common notification messages
  messages: {
    listingViewed: 'تمت مشاهدة إعلانك "{{title}}"',
    newContact: 'لديك تواصل جديد على إعلان "{{title}}"',
    listingSaved: 'قام شخص بحفظ إعلانك "{{title}}"',
    listingExpiringSoon: 'سينتهي إعلانك "{{title}}" خلال {{days}} أيام',
    listingExpired: 'انتهى إعلانك "{{title}}"',
    subscriptionExpiringSoon: 'سينتهي اشتراكك خلال {{days}} أيام',
    subscriptionExpired: 'انتهى اشتراكك',
    subscriptionRenewed: 'تم تجديد اشتراكك بنجاح',
    licenseExpiringSoon: 'ستنتهي رخصتك خلال {{days}} أيام',
    licenseExpired: 'انتهت صلاحية رخصتك',
    newReview: 'حصلت على تقييم جديد',
    leadResponse: 'لديك رد على طلبك',
    viewMilestone: 'وصل إعلانك "{{title}}" إلى {{count}} مشاهدة!',
  },

  // Actions
  actions: {
    view: 'عرض',
    renew: 'تجديد',
    upgrade: 'ترقية',
    respond: 'رد',
    dismiss: 'تجاهل',
  },

  // Filters
  filters: {
    all: 'الكل',
    unread: 'غير مقروءة',
    listings: 'الإعلانات',
    subscription: 'الاشتراك',
    reviews: 'التقييمات',
    system: 'النظام',
  },

  // Settings
  settings: {
    title: 'إعدادات الإشعارات',
    subtitle: 'تحكم في الإشعارات التي تتلقاها',

    // Channels
    channels: {
      title: 'قنوات الإشعارات',
      email: 'البريد الإلكتروني',
      emailDescription: 'استلم الإشعارات عبر البريد الإلكتروني',
      push: 'إشعارات الدفع',
      pushDescription: 'استلم إشعارات فورية على جهازك',
      sms: 'الرسائل النصية',
      smsDescription: 'استلم إشعارات عبر SMS',
    },

    // Categories
    categories: {
      title: 'أنواع الإشعارات',
      listings: 'إشعارات الإعلانات',
      listingsDescription: 'المشاهدات والتواصل والحفظ',
      subscription: 'إشعارات الاشتراك',
      subscriptionDescription: 'التجديد والانتهاء والفواتير',
      marketing: 'العروض الترويجية',
      marketingDescription: 'العروض والخصومات والأخبار',
      reviews: 'إشعارات التقييمات',
      reviewsDescription: 'التقييمات الجديدة والردود',
    },

    // Frequency
    frequency: {
      title: 'تكرار الإشعارات',
      realtime: 'فوري',
      realtimeDescription: 'استلم الإشعارات فور حدوثها',
      daily: 'ملخص يومي',
      dailyDescription: 'استلم ملخصاً يومياً للإشعارات',
      weekly: 'ملخص أسبوعي',
      weeklyDescription: 'استلم ملخصاً أسبوعياً للإشعارات',
    },

    // Actions
    save: 'حفظ الإعدادات',
    saved: 'تم حفظ الإعدادات',
    reset: 'إعادة الضبط',
  },

  // Time
  time: {
    now: 'الآن',
    minutesAgo: 'منذ {{count}} دقيقة',
    hoursAgo: 'منذ {{count}} ساعة',
    daysAgo: 'منذ {{count}} يوم',
    weeksAgo: 'منذ {{count}} أسبوع',
  },

  // Status
  status: {
    read: 'مقروء',
    unread: 'غير مقروء',
  },
};

export default notifications;
